import compactObject from '../../util/compactObject';
import fullNameParts from '../../util/fullNameParts';
import getCookieOrMeta from '../../storage/getCookieOrMeta';
import getFieldValue from '../elements/getFieldValue';
import getForm from '../elements/getForm';
import submitForm from './submitForm';
import { pushAccountCreated, pushLeadCreated } from '../../tracking/send_to_gtm';
import getPageValue from './getPageValue';
import getMessageValue from './getMessageValue';
import { validateCreateUser } from '../validation/submitValidation';
import trackFormWizardSubmissionEvents from './trackFormWizardSubmissionEvents';

function getFormUrl() {
  return `https://${process.env.API_HOST}/v1/learn-lab/users`;
}

function getFormData(form, userType) {
  const [firstName, lastName] = fullNameParts(getFieldValue(form, 'full_name') || '');
  return compactObject({
    first_name: firstName.trim(),
    last_name: lastName.trim(),
    email: getFieldValue(form, 'email'),
    phone: getFieldValue(form, 'phone_number'),
    password: getFieldValue(form, 'password'),
    type: userType || 'homepage_client',
    message: getMessageValue(form),
    cookies: {
      visitor_id: getCookieOrMeta('visitor-id'),
      referer: getCookieOrMeta('referer') || '',
      landing_page: getCookieOrMeta('landing_page'),
      page: getPageValue(form)
    }
  });
}

export default async function createUser(step) {
  const form = getForm(step);
  const userType = step.dataset.userType;
  const formData = getFormData(form, userType);
  const formVersion = getFieldValue(form, 'leadform');
  const url = getFormUrl();

  validateCreateUser(formData);

  const promise = submitForm(url, { formData: formData, formVersion: formVersion }, 'POST', { mode: 'cors', credentials: 'include', redirect: 'follow' })
    .then((resp) => {
      pushAccountCreated(form, { account_id: resp.userID });
      pushLeadCreated(form, { lead_type: 'classes' });
    });

  return trackFormWizardSubmissionEvents(promise, step, 'user_creation');
}
